import { render } from "./LHDNLogsContent.vue?vue&type=template&id=a50186d6&scoped=true"
import script from "./LHDNLogsContent.vue?vue&type=script&lang=js"
export * from "./LHDNLogsContent.vue?vue&type=script&lang=js"

import "./LHDNLogsContent.vue?vue&type=style&index=0&id=a50186d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50186d6"]])

export default __exports__